<app-loader [isLoading]="isLoading"></app-loader>
<div class="header">
    <div class="top">
        <a routerLink="/home/dining/general">
            <h3>Comedor /</h3>
            <div class="breadcrumb">
                <mat-icon svgIcon="arrow back"></mat-icon>
                <h2> Editar reservas sin empleado</h2>
            </div>
        </a>
    </div>
</div>
<div class="content form">
    <div class="reservation">
        <h3>ESCRIBA EL NÚMERO DE RESERVAS SIN EMPLEADO</h3>
        <form [formGroup]="configForm">
            <mat-form-field appearance="outline">
                <input matInput type="number" formControlName="extra_menus">
                @if (configForm.get('extra_menus')?.hasError('required')) {
                <mat-error>
                    Este campo es requerido
                </mat-error>
                }
                @if (configForm.get('extra_menus')?.hasError('min')) {
                <mat-error>
                    El valor debe ser mayor o igual a 0
                </mat-error>
                }
            </mat-form-field>
        </form>
        <div class="buttons">
            <button mat-flat-button id="action" (click)="saveChanges()">Guardar cambios</button>
            <button mat-flat-button id="cancel" (click)="cancel()">Cancelar</button>
        </div>
    </div>
</div>